// extracted by mini-css-extract-plugin
export var container = "dg_c";
export var image = "dg_d9";
export var titleContainer = "dg_cX";